(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-button.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-button.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  useSelector
} = ReactRedux;
const formatCurrency = svs.utils.format.Currency;
const {
  amountLimits
} = svs.accountservicesReact.deposit.constants;
const DepositButton = _ref => {
  let {
    isSubmitDisabled = false
  } = _ref;
  const isDepositAndPay = useSelector(state => {
    var _state$deposit$instan;
    return (_state$deposit$instan = state.deposit.instantPay) === null || _state$deposit$instan === void 0 ? void 0 : _state$deposit$instan.isDepositAndPay;
  });
  const amount = useSelector(state => state.deposit.amount);
  const formatButtonText = () => {
    if (isDepositAndPay) {
      return 'Sätt in och betala';
    }
    const money = Number.parseInt(amount, 10);
    if (money >= amountLimits.MIN && money <= amountLimits.MAX) {
      return "S\xE4tt in ".concat(formatCurrency(money), " kr");
    }
    return 'Sätt in pengar';
  };
  return React.createElement(Button, {
    block: true,
    className: "margin-xs-top-2",
    disabled: isSubmitDisabled,
    focus: true,
    size: 300,
    type: "submit"
  }, formatButtonText());
};
svs.accountservicesReact.deposit.depositShared.DepositButton = DepositButton;

 })(window);